import React, { useMemo, useState, useCallback } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import swal from 'sweetalert';
import { producaov2 } from '../../../../services/apis';
import DataTable from '../../../../components/DataTable';
import AdminMenu from '../../../../components/Admin/MenuDetalhes/AdminMenu';
import useInteressadosMBA, { INTERESSADOS_MBA_FILTERS } from './useInteressadosMBA';

export default function InteressadosMBA() {
  const {
    data,
    total,
    filters,
    page,
    isLoading,
    rowsPerPage,
    changeFilters,
    resetFilters,
    changePage,
    changeRowsPerPage,
  } = useInteressadosMBA();

  const [isExporting, setIsExporting] = useState(false);

  const rows = useMemo(() => {
    if(!data) {
      return [];
    }

    return data?.map(row => {
      return {
        name: row?.nome,
        email: row?.email,
        mba: row?.mba,
        registrationDate: row?.data_registro 
          ? new Date(row.data_registro).toLocaleDateString('pt-BR', { 
              timeZone: 'UTC', 
              day: '2-digit', 
              month: '2-digit', 
              year: 'numeric' 
            }) 
          : '-', 
      }
    })
  }, [data]);

  const handleExport = useCallback(async () => {
    setIsExporting(true);

    let hasError = false;

    try {
      const res = await producaov2.post("/admin/reports/interessados-mba", filters);
      
      if (res.data && res.data.url) {
        window.open(res.data.url, "_blank");
      }

    } catch (error) {
      hasError = true;

      if (!error.response) {
        return;
      }

      if (error?.response?.status === 404) {
        return swal(
          `Ocorreu um erro ao gerar o relatório`,
          `Entre em contato com o time de TI`,
          "error",
        );
      }

      swal(
        `Algo deu errado na geração do relatório em Excel`,
        `Entre em contato com o time de TI`,
        "error",
      );
    } finally {
      setIsExporting(false);

      if (!hasError) {
        swal("Confirmado!", "Relatório gerado com sucesso", "success");
      }
    }
  }, [filters]);

  return (
    <Box width="100%" paddingLeft="250px">
      <Box width="100%" padding="1rem">
        <AdminMenu />
        
        <DataTable
          showFilters
          showPagination
          defaultOpenedFilters
          maxHeight="70vh"
          hasStickHeader
          filters={[
            { 
              key: INTERESSADOS_MBA_FILTERS.NOME, 
              name: 'Nome', 
              component: { type: 'text', placeholder: 'Busque pelo Nome' } 
            },
            { 
              key: INTERESSADOS_MBA_FILTERS.EMAIL, 
              name: 'Email', 
              component: { type: 'text', placeholder: 'Busque pelo Email' } 
            },
            { 
              key: INTERESSADOS_MBA_FILTERS.DATA_INICIO, 
              name: 'Data Início', 
              component: { type: 'date' } 
            },
            { 
              key: INTERESSADOS_MBA_FILTERS.DATA_FIM, 
              name: 'Data Fim', 
              component: { type: 'date' } 
            },
            { 
              key: INTERESSADOS_MBA_FILTERS.REMOVE_TEST, 
              name: 'Remover Testes', 
              component: { type: 'checkbox' } 
            },
            { 
              key: INTERESSADOS_MBA_FILTERS.ONLY_PAID, 
              name: 'Somente Pagos', 
              component: { type: 'checkbox' } 
            },
            { 
              key: INTERESSADOS_MBA_FILTERS.ONLY_ASSIGNED, 
              name: 'Somente Atribuídos', 
              component: { type: 'checkbox' } 
            },
          ]}
          columns={[
            { key: 'name', name: 'Nome', isSingleLine: true, maxWidth: '250px' },
            { key: 'email', name: 'Email', isSingleLine: true, maxWidth: '250px' },
            { key: 'mba', name: 'MBA', isSingleLine: true, maxWidth: '300px' },
            { key: 'registrationDate', name: 'Data de Registro', isSingleLine: true },
          ]}
          rows={rows}
          page={page}
          rowsPerPage={rowsPerPage}
          isLoading={isLoading}
          selectedFilters={filters}
          totalRecords={total}
          onPageChange={changePage}
          onRowsPerChange={changeRowsPerPage}
          onSubmitFilters={changeFilters}
          onResetFilters={resetFilters}
          CustomToolbarElement={
            <Box display="flex" alignItems="center" style={{ gap: '16px' }}>
              <Typography variant="h5" component="h1">Interessados MBA</Typography>
              
              <Button
                variant="contained"
                color="primary"
                startIcon={<GetApp />}
                onClick={handleExport}
                disabled={isLoading || isExporting} 
              >
                {isExporting ? 'Gerando...' : 'Exportar'}
              </Button>
            </Box>
          }
        />
      </Box>
    </Box>
  );
}